import React from 'react';
import { formatDistance } from 'date-fns'


const DEFAULT_VIDEO_VOLUME = 1
const DEFAULT_PLAYBACK_RATE = 1


const Spinner = props =>
    <svg className={'Spinner ' + props.className} viewBox="0 0 50 50" style={props.style || {}}>
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
    </svg>


/*
const Expandable = ({ children, maxHeight = 190, startExpanded}) => {
	const [isExpanded, setIsExpanded] = useState(startExpanded);
	const [contentHeight, setContentHeight] = useState(0);
	const contentRef = useRef(null);

	useEffect(() => {
		setContentHeight(Math.round(contentRef.current.clientHeight))
	}, []);

    const collapsed = !isExpanded && contentHeight > maxHeight

    return (
        <div className='Expandable' ref={contentRef}>
            <div style={collapsed ? {maxHeight: maxHeight + 'px', overflow: 'hidden'} : {}}>
                { children }
            </div>
            {collapsed && <div className='Expandable-expander'>
                <div className='flex flex-justify' onClick={() => setIsExpanded(true) }>
                    <button className='button'>expand</button>
                </div>
             </div>}
        </div>
    )
}
*/

class ResizingTextarea extends React.Component {
    constructor (props) {
        super(props)
        this.resize = this.resize.bind(this)
        this.textareaRef = React.createRef()
    }

    componentDidMount (e) {
        const ref = this.props.textareaRef || this.textareaRef
        this._doResize(ref.current)
        if (this.props.autofocus) {
            ref.current.focus()
        }
    }

    resize(e) {
        this._doResize(e.target)
    }

    onKeyDown(e) {
        // handle tab key as inserting a tab
        if (e.key === 'Tab') {
            e.preventDefault()
            const s = e.target.selectionStart
            e.target.value = e.target.value.substring(0, s) + "\t" + e.target.value.substring(e.target.selectionEnd);
            e.target.selectionEnd = s+1;
        }
    }

    _doResize (el) {
        // mutate style directly... don't rely on React,
        // since we need to reset then set
        var computed = getComputedStyle(el)
        el.style.height = 'auto'
        var target = el.scrollHeight - parseFloat(computed.paddingTop) - parseFloat(computed.paddingBottom)
        el.style.height = target + 'px'
    }

    render () {
        return <textarea
            rows={this.props.rows || 2}
            className={this.props.className}
            defaultValue={this.props.defaultValue}
            placeholder={this.props.placeholder}
            style={{overflowY: 'hidden'}}
            ref={this.props.textareaRef || this.textareaRef}
            onInput={this.resize}
            onKeyDown={this.onKeyDown}
        />
    }
}

class CommentEditor extends React.Component {
    constructor () {
        super()
        this.state = {
            previewing: false,
            refocusTextarea: false
        }
        this.togglePreview = this.togglePreview.bind(this)
    }

    togglePreview () {
        if (this.state.previewing) {
            this.setState({
                previewing: false,
                refocusTextarea: true
            })
        } else {
            this.setState({
                previewing: true,
                loading: true,
                refocusTextarea: false
            })
        window.post('/markdown/', {
            content: this.props.textareaRef.current.value
        })
        .then(
            (result) => {
                if (result.status === 200) {
                    result.json().then(data => {
                        this.setState({
                            html: data.html,
                            loading: false
                        })
                    })
                } else {
                    console.error('Error retrieving markdown preview')
                }
            },
            (error) => {
                console.error(error)
            }
        )
            
        }
    }

    componentDidUpdate (prevProps, prevState) {
        if (this.state.refocusTextarea && !prevState.refocusTextarea) {
            this.props.textareaRef.current.focus()
        }
    }

    render () {
        return (
            <div className="CommentEditor">
                <div className="CommentEditor-top flex">
                    <span className={'CommentEditor-tab' + (this.state.previewing ? '' : ' active')} onClick={this.togglePreview}>Write</span>
                    <span className={'CommentEditor-tab' + (this.state.previewing ? ' active' : '')} onClick={this.togglePreview}>Preview</span>
            {this.state.loading && <span className='mt1'>
                        <Spinner className='small static black' />
                    </span>}
                    <span className="flex-auto"></span>
                    <div className='Tooltip mt1'>
                        <div className='Tooltip-marker'>
                            <img className='invert' src='/static/markdown.svg' alt='markdown syntax' style={{height: '1.2em', opacity: 'var(--op-disabled)'}} />
                        </div>
                        <div className='Tooltip-bubble'>
                            <div className='Tooltip-bubbleInner'>
                                Permitted markdown includes<br />_italic_, **bold**, [anchor](url) and<br />```[lang] ... ``` syntax highlighting
                            </div>
                            <div className='Tooltip-triangle' />
                        </div>
                    </div>
                </div>
                <div className={'CommentEditor-content' + (this.state.previewing ? ' previewing' : '')}>
                    
                    <div className='CommentEditor-preview' dangerouslySetInnerHTML={{__html: this.state.html}} />
                    <ResizingTextarea {...this.props} />
                </div>
                <div className="CommentEditor-bottom flex">
                    <span className={'ResponseTextarea-status flex-auto ' + this.props.statusClass}>
                        {this.props.statusClass === 'saving' ? <Spinner className='small black static' /> : this.props.statusText}
                    </span>
                    <button disabled={this.props.statusClass === 'saving'} mt={2} mr={3} className="button right">{this.props.buttonValue || 'submit'}</button>
                </div>
            </div>
        )
    }
}


const timeFormat = (s, padMinutes=true) => {
    // Given a time in seconds as a float, return formatted string like h:mm:ss
    let out = Math.floor(s % 60).toFixed()
    if (out.length === 1) out = '0' + out
    let mm = Math.floor((s / 60) % 60).toFixed()
    const h = Math.floor(s / 3600).toFixed()
    if (mm.length === 1 && padMinutes) mm = '0' + mm
    out = mm + ':' + out
    if (h !== '0') {
        out = h + ':' + out
    }
    return out
}

const TOOLTIP_SPACE = 8

class Tooltip extends React.Component {
    constructor () {
        super()
        this.bubbleRef = React.createRef()
    }
    componentDidUpdate(prevProps, prevState) {
        // nudge the inner bubble enough that it's inside the viewport, with 4px buffer
        const rect = this.bubbleRef.current.parentElement.getBoundingClientRect()
        const lnudge = TOOLTIP_SPACE - rect.x
        const rnudge = rect.x + rect.width + TOOLTIP_SPACE - window.innerWidth
        if (rect.left && lnudge > 0) {
            this.bubbleRef.current.style.left = `${lnudge}px`;
        } else if (rnudge > 0) {
            this.bubbleRef.current.style.left = `-${rnudge}px`
        } else {
            this.bubbleRef.current.style.left = null
        }
    }
    render () {
        return <div className={'Tooltip ' + (this.props.showing ? 'Tooltip-showing' : '')} style={{left: this.props.left || 'unset' }} onClick={this.props.onClick}>
            <div className='Tooltip-marker' />
            <div className='Tooltip-bubble'>
                <div ref={this.bubbleRef} className='Tooltip-bubbleInner'>
                    {this.props.children}
                </div>
                <div className='Tooltip-triangle' />
            </div>
        </div>
    }
}


const bufferEnd = video => {
    // The end of the last buffered chunk
    if (video.buffered.length === 0) return 0
    return video.buffered.end(video.buffered.length - 1)
}


class VerticalSlider extends React.Component {
    constructor(props) {
        super(props)
        this.state = {dragging: false}
        this.trackEl = React.createRef()
        this.dragStart = this.dragStart.bind(this)
        this.dragging = this.dragging.bind(this)
        this.dragEnd = this.dragEnd.bind(this)
    }

    componentDidMount () {
        window.addEventListener('mousemove', this.dragging)
        window.addEventListener('mouseup', this.dragEnd)
    }

    componentWillUnmount () {
        window.removeEventListener('mousemove', this.dragging)
        window.removeEventListener('mouseup', this.dragEnd)
    }

    dragStart (e) {
        this.setState({dragging: true})
        if (this.props.setValue) {
            const position = this.relativePosition(e.clientY)
            if (position !== undefined) this.props.setValue(position)
        }
    }

    dragging (e) {
        if (this.state.dragging && this.props.setValue) {
            const position = this.relativePosition(e.clientY)
            if (position !== undefined) this.props.setValue(position)
        }
    }

    dragEnd () {
        this.setState({dragging: false})
    }

    relativePosition (y) {
        const rect = this.trackEl.current.getBoundingClientRect()
        if (rect.height === 0) return undefined
        let position = (rect.height + rect.y - y) / rect.height
        if (position < 0) position = 0
        if (position > 1) position = 1
        return position
    }


    render () {
        const valuePercent = this.props.value * 100 + '%'
        return (
            <div
                className={this.props.className}
                onMouseDown={this.dragStart}
                style={{
                    padding: '0 15px',
                    cursor: 'pointer',
                    position: 'relative',
                    height: '80px',
                }}
            >
                <div  /* track */
                    ref={this.trackEl}
                    style={{
                        backgroundColor: 'var(--bg3)',
                        position: 'relative',
                        width: '4px',
                        height: '100%',
                    }}
                >
                    <div  /* progress */
                        style={{
                            backgroundColor: 'var(--bright-green)',
                            position: 'absolute',
                            height: valuePercent,
                            bottom: '0px',
                            width: '100%',
                        }}
                    />
                </div>
                <div  /* handle */
                    style={{
                        backgroundColor: 'white',
                        width: '11px',
                        height: '11px',
                        bottom: valuePercent,
                        boxShadow: 'var(--elevation-2)',
                        position: 'absolute',
                        borderRadius: '999px',
                        left: '12px',
                        transform: 'translateY(50%)',
                    }}
                    onMouseDown={this.dragStart}
                />
            </div>
        )
    }
}


class MovableCaptions extends React.Component {
    constructor () {
        super()
        this.state = {
            dragging: false,
            rel: null,
            pos: {
                x: 0,
                y: 0
            },
            bottom: null,
        }
        this.onMouseUp = this.onMouseUp.bind(this)
        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseMove = this.onMouseMove.bind(this)
        this.ref = React.createRef()
    }
    onMouseDown (e) {
        if (e.button !== 0) return
        this.setState({
            dragging: true,
            rel: {
                x: e.pageX - this.ref.current.offsetLeft,
                y: e.pageY - this.ref.current.offsetTop
            }
        })
        e.stopPropagation()
        e.preventDefault()
    }
    componentDidUpdate (props, state) {
        if (this.state.dragging && !state.dragging) {
          document.addEventListener('mousemove', this.onMouseMove)
          document.addEventListener('mouseup', this.onMouseUp)
        } else if (!this.state.dragging && state.dragging) {
          document.removeEventListener('mousemove', this.onMouseMove)
          document.removeEventListener('mouseup', this.onMouseUp)
        }
      }
    onMouseUp (e) {
        this.setState({dragging: false})
        e.stopPropagation()
        e.preventDefault()
    }
    onMouseMove (e) {
        if (!this.state.dragging) return
        const rect = this.ref.current.getBoundingClientRect()
        const prect = this.ref.current.offsetParent.getBoundingClientRect()
        const maxLeft = prect.width - rect.width
        const maxTop = prect.height - rect.height
        let x = e.pageX - this.state.rel.x
        let y = e.pageY - this.state.rel.y
        if (x < 0) x = 0
        if (x > maxLeft) x = maxLeft
        if (y < 0) y = 0
        if (y > maxTop) y = maxTop
        this.setState({
            pos: {xpc: (100 * x / prect.width) + '%', ypc: (100 * y / prect.height) + '%'},
            bottom: 'unset'
        })
        e.stopPropagation()
        e.preventDefault()
    }
    render () {
        return (
            <div ref={this.ref} onMouseDown={this.onMouseDown} onMouseMove={this.onMouseMove} onMouseUp={this.onMouseUp} className='MovableCaptions' style={{left: this.state.pos.xpc, top: this.state.pos.ypc, bottom: this.state.bottom}}>
                {this.props.children}
            </div>
        )
    }
}


const VideoVolumeControl = props => {
    const button = <span className='plain-button' onClick={props.toggleVideoMuted}>
        <i className="material-icons">{props.videoMuted ? 'volume_off' : 'volume_up'}</i>
    </span>
    const slider = <VerticalSlider
        value={props.videoMuted ? 0 : props.videoVolume}
        setValue={props.setVideoVolume}
    />
    return (
        <div className='VideoVolumeControl' style={{position: 'relative', width: '32px', height: '32px'}}
>
            <div style={{position: 'absolute', bottom: '0'}}>
                <div className='VideoVolumeControl-slider py3'>{slider}</div>
            </div>
            <div style={{position: 'absolute', bottom: '0'}}>
                {button}
            </div>
        </div>
    )
}


const Prompt = props =>
    <div onClick={props.onClick} style={{height: '100%', overflowY: 'auto', position: 'relative'}}>
        <div className='Prompt' style={{width: '640px', margin: '100px auto'}}>
            <div className='p3 m1'>
                <h2 className="mx1 mb3" dangerouslySetInnerHTML={{__html: props.prompt}} />
                <p className="muted mx1 mb1">Have a question? Ask below or on the <a href={props.discordURL}>#{props.discordChannelName}</a> discord channel.</p>
            </div>
        </div>
    </div>


class VideoPlayer extends React.Component {
    constructor (props) {
        super(props)
        const getLocal = (key, dflt) => localStorage.getItem(key) || dflt
        // To choose source: use first (ie highest res) source unless another is in localStorage and available
        const sourceName = localStorage.getItem('sourceName')
        const source = props.data.sources.filter(x => x[0] === sourceName)[0] || props.data.sources[0]
        this.state = {
            currentPrompt: null,
            currentOverlay: -1,
            currentTime: 0,  // State of video for rendering purposes: derived from this.props.videoRef.current.currentTime
            showSpinner: true,
            isFullScreen: false,
            videoVolume: parseFloat(getLocal('videoVolume', DEFAULT_VIDEO_VOLUME)),
            playbackRate: parseFloat(getLocal('playbackRate', DEFAULT_PLAYBACK_RATE)),
            videoMuted: getLocal('videoMuted', 'false') === 'true',
            lastHover: null,
            showCaptions: getLocal('showCaptions', true) === 'true',
            source: source
        }
        this.fullScreenEnabled = !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled)

        this.playerRef = React.createRef()
        this.play = this.play.bind(this)
        this.pause = this.pause.bind(this)
        this.playPause = this.playPause.bind(this)
        this.setPausePoint = this.setPausePoint.bind(this)
        this.setVideoVolume = this.setVideoVolume.bind(this)
        this.tick = this.tick.bind(this)
        this.toggleFullScreen = this.toggleFullScreen.bind(this)
        this.setVideoMuted = this.setVideoMuted.bind(this)
        this.toggleVideoMuted = this.toggleVideoMuted.bind(this)
        this.toggleCaptions = this.toggleCaptions.bind(this)
        this.handleKeydown = this.handleKeydown.bind(this)
        this.setPlaybackRate = this.setPlaybackRate.bind(this)
        this.setSource = this.setSource.bind(this)
        this.sendWatchEvent = this.sendWatchEvent.bind(this)
        this.progressEl = React.createRef()
        this.handleClickProgress = this.handleClickProgress.bind(this)
        this.handleClickPauseMarker = this.handleClickPauseMarker.bind(this)
        this.handleHoverProgress = this.handleHoverProgress.bind(this)
        this.handleLeaveProgress = this.handleLeaveProgress.bind(this)
        this.hasRecentlyHovered = this.hasRecentlyHovered.bind(this)
        this.hideProgressHover = this.hideProgressHover.bind(this)
        this.noteRecentHover = this.noteRecentHover.bind(this)
        this.scrubberDragStart = this.scrubberDragStart.bind(this)
        this.scrubberDrag = this.scrubberDrag.bind(this)
        this.scrubberDragEnd = this.scrubberDragEnd.bind(this)
        this.showSpinner = this.showSpinner.bind(this)
        this.hideSpinner = this.hideSpinner.bind(this)
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.scrubberDrag)
        window.addEventListener('mousemove', this.noteRecentHover)
        window.addEventListener('mouseup', this.scrubberDragEnd)
        const that = this
        const setFullScreenState = (x) => that.setState({isFullScreen: x})
        window.setInterval(this.tick, 30)  // approx once per frame
        document.addEventListener('fullscreenchange', () => {
           setFullScreenState(!!(document.fullScreen || document.fullscreenElement))
        })
        document.addEventListener('webkitfullscreenchange', () => {
           setFullScreenState(!!document.webkitIsFullScreen);
        });
        document.addEventListener('mozfullscreenchange', () => {
           setFullScreenState(!!document.mozFullScreen);
        })
        document.addEventListener('msfullscreenchange', () => {
           setFullScreenState(!!document.msFullscreenElement);
        })
        document.addEventListener('keydown', this.handleKeydown)
        // For logged in users, track watch time
        if (this.props.data.userId) {
            this.props.videoRef.current.addEventListener('timeupdate', function () {
                const t = that.props.videoRef.current.currentTime
                if (that.lastWatched === undefined || t > that.lastWatched + 5 || t < that.lastWatched) {  // Do it every 5 seconds, or if user seeks back
                    that.sendWatchEvent()
                    that.lastWatched = t
                }
            })
        }
        this.props.videoRef.current.addEventListener('timeupdate', function () {
            that.setState({currentTime: that.props.videoRef.current.currentTime})
        })
        function onLoadedMetadata () {
            that.props.videoRef.current.removeEventListener('loadedmetadata', onLoadedMetadata)
            // Possibly seek to t param or lastWatch from backend data
            const url = new URL(window.location.href);
            const t = url.searchParams.get('t');
            if (t) {
                that.props.videoRef.current.currentTime = t
            } else if (that.props.data.lastWatch && that.props.videoRef.current.duration - that.props.data.lastWatch > 10) {
                that.props.videoRef.current.currentTime = that.props.data.lastWatch
            }
            // Show subtitles in our own UI
            const track = that.props.videoRef.current.textTracks[0]
            track.oncuechange = function () {
                const cue = track.activeCues[0]
                if (cue) {
                    const caption = cue.text.replace(/<v.([^>]+)>/g, '<span class="subtitle-$1">').replace(/<\/v>/g, '</span>')
                    that.setState({caption: caption})
                }
            }
        }
        this.props.videoRef.current.addEventListener('loadedmetadata', onLoadedMetadata)
    }
    
    componentWillUnmount () {
        window.cancelAnimationFrame(this.requestId)
        window.removeEventListener('mousemove', this.noteRecentHover)
        window.removeEventListener('mousemove', this.scrubberDrag)
        window.removeEventListener('mouseup', this.scrubberDragEnd)
    }   

    handleClickProgress (e) {
        // when the progress bar is clicked, seek to the correct location
        e.stopPropagation()
        // TODO ensure video is actually loaded, otherwise setting current time
        // will error
        const rect = this.progressEl.current.getBoundingClientRect()
        const offset = e.clientX - rect.x
        let position = offset / rect.width
        if (position < 0) position = 0
        if (position > 1) position = 1
        this.props.videoRef.current.currentTime = this.props.videoRef.current.duration * position
        if (this.props.videoRef.current.paused) this.play()
    }

    handleClickPauseMarker (e, x) {
        e.stopPropagation()
        this.props.videoRef.current.currentTime = x.timestamp
        if (x.prompt) {
            this.setPausePoint(x)
        }
    }
    
    handleHoverProgress (e) {
        const duration = this.props.videoRef.current.duration
        if (!(duration > 0)) { return; }  // guard against NaN, undefined, and 0
        const rect = this.progressEl.current.getBoundingClientRect()
        const offset = e.clientX - rect.x
        let position = offset / rect.width
        if (position < 0) position = 0
        if (position > 1) position = 1
        this.setState({
            progressHoverText: timeFormat(duration * position),
            progressHoverLeft: 100 * position + '%'
        })
    }

    handleLeaveProgress () {
        this.setState({
            progressHoverText: null,
            progressHoverLeft: null
        })
    }

    hasRecentlyHovered () {
        return this.state.lastHover && (new Date() - this.state.lastHover < 2000)
    }

    hideProgressHover (e) {
        e.stopPropagation()
        this.setState({
            progressHoverText: null,
            progressHoverLeft: null
        })
    }
    
    play () {
        this.props.videoRef.current.volume = this.state.videoVolume
        const playPromise = this.props.videoRef.current.play()
        if (playPromise !== undefined) {
            playPromise.then(() => {
                this.setState({
                    currentPrompt: null,
                    lastPlayTime: new Date(),
                })
            })
            .catch(error => console.error(error))
        }
    }

    pause () {
        this.props.videoRef.current.pause()
    }

    playPause () {
        if (this.props.videoRef.current.paused) {
            this.play()
        } else {
            this.pause()
        }
    }


    scrubberDragStart (e) {
        this.isScrubbing = true
        this.pausedScrubbing = this.props.videoRef.current.paused
        if (!this.pausedScrubbing) this.pause()
    }

    scrubberDrag (e) {
        // TODO can probably reuse the slider componont for scrubber
        if (!this.isScrubbing) return
        const rect = this.progressEl.current.getBoundingClientRect()
        const offset = e.clientX - rect.x
        let position = offset / rect.width
        if (position < 0) position = 0
        if (position > 1) position = 1
        this.props.videoRef.current.currentTime = this.props.videoRef.current.duration * position
        this.setState({currentTime: this.props.videoRef.current.currentTime})
    }

    scrubberDragEnd () {
        if (!this.isScrubbing) return
        this.isScrubbing = false
        if (!this.pausedScrubbing) this.play()
    }

    showSpinner () {
        this.setState({showSpinner: true})
    }

    hideSpinner () {
        this.setState({showSpinner: false})
    }
    
    noteRecentHover () {
        this.setState({lastHover: new Date()})
    }


    handleKeydown (e) {
        // Ignore video keyboard shortcuts when focused on anything
        if (document.activeElement.tagName !== 'BODY') return
        switch (e.key) {
            case "Right":
            case "ArrowRight":
                // Jump forward 5 secs
                this.props.videoRef.current.currentTime += 5 * this.props.videoRef.current.playbackRate
                if (this.state.currentPrompt) this.playPause()
                break
            case "Left":
            case "ArrowLeft":
                // Jump back 5 secs
                this.props.videoRef.current.currentTime -= 5 * this.props.videoRef.current.playbackRate
                if (this.state.currentPrompt) this.playPause()
                break
            case " ":
                // On space, play/pause the video
                this.playPause() 
                break
            default:
                return
        }
        e.preventDefault()
    }

    setPlaybackRate (x) {
        this.props.videoRef.current.playbackRate = x
        this.setState({playbackRate: x})
        localStorage.setItem('playbackRate', x)
    }

    setSource (i) {
        const video = this.props.videoRef.current
        const currentTime = video.currentTime
        const paused = video.paused
        this.setState({source: this.props.data.sources[i]})
        localStorage.setItem('sourceName', this.props.data.sources[i][0])
        video.load()
        video.currentTime = currentTime
        if (!paused) video.play()
    }

    setVideoMuted (val) {
        this.setState({videoMuted: val})
        localStorage.setItem('videoMuted', val)
        this.props.videoRef.current.muted = val
    }

    sendWatchEvent () {
        if (process.env.NODE_ENV === 'production') {
            window.post('/stats/watch/', {
                path: window.location.pathname,
                time: this.props.videoRef.current.currentTime,
                speed: this.props.videoRef.current.playbackRate
            })
        }
    }

    toggleVideoMuted () {
        const currentlyMuted = this.state.videoMuted
        // if unmuting and volume is zero, set volume to default for better UX
        // this will also have the _consequence_ of unmuting
        if (currentlyMuted && this.state.videoVolume === 0) {
            this.setVideoVolume(DEFAULT_VIDEO_VOLUME)
            return
        }
        this.setVideoMuted(!currentlyMuted)
    }

    toggleCaptions () {
        const show = !this.state.showCaptions
        this.setState({showCaptions: show})
        localStorage.setItem('showCaptions', show)
    }

    setVideoVolume (target) {
        this.props.videoRef.current.volume = target
        this.setVideoMuted(target === 0)
        this.setState({videoVolume: target})
        localStorage.setItem('videoVolume', target)
    }

    tick () {
        const video = this.props.videoRef.current
        this.setState((state, props) => {
            var currentOverlay = -1
            var overlayDuration = 5 * this.props.videoRef.current.playbackRate
            for (var i = 0; i < this.props.data.overlays.length; i++) {
                var overlay = this.props.data.overlays[i]
                if (video.currentTime > overlay[0] && video.currentTime < overlay[0] + overlayDuration) {
                    currentOverlay = i
                }
            }
            if (currentOverlay !== state.currentOverlay) return {currentOverlay: currentOverlay}
        })
        if (!this.props.data || !this.props.data.parts) return  // TODO split out players for problems and explainers?
        if (!this.pausePoints) {
            this.pausePoints = this.props.data.parts
            this.pausePoints.reverse()
        }
        this.setState((state, props) => {
            // detect if we have arrived at a pause point, and if so pause.
            // no point doing this if we're not playing
            if (state.currentPrompt) return
            
            for (var p of this.pausePoints) {
                if (p.timestamp === state.activePausePosition) continue

                if (video.currentTime > p.timestamp - 0.2 && video.currentTime <= p.timestamp) {
                    this.setPausePoint(p)
                    return
                }
            }
            
            const pp = state.activePausePosition
            if (pp && (video.currentTime - 1 > pp || video.currentTime + 1 < pp))
                return {activePausePosition: null}
        })
    }

    setPausePoint (p) {
        this.setState((state, props) => {
            this.props.videoRef.current.pause()
            return {
                currentPrompt: p,
                activePausePosition: p.timestamp
            }
        })
    }

    toggleFullScreen (e) {
        e.stopPropagation()
        const el = this.playerRef.current
        const isFullScreen = !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement)
        if (isFullScreen) {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
        } else {
            if (el.requestFullscreen) el.requestFullscreen();
            else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
            else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
            else if (el.msRequestFullscreen) el.msRequestFullscreen();
        }
        this.setState({isFullScreen: isFullScreen})
    }
    
    render () {
        let v, progressStyle, bufferStyle
        if (this.props.videoRef.current) {
            v = {
                duration: this.props.videoRef.current.duration,
                buffered: bufferEnd(this.props.videoRef.current),
                paused: this.props.videoRef.current.paused
            }
            progressStyle = {
                height: '100%',
                position: 'absolute',
                width: 100 * this.state.currentTime / v.duration + '%'
            }
            bufferStyle = {width: 100 * v.buffered / v.duration + '%'}
            this.props.videoRef.current.playbackRate = this.state.playbackRate
            this.props.videoRef.current.muted = this.state.videoMuted
        } else {
            v = {
                duration: null,
                buffered: 0,
                paused: true
            }
            progressStyle = {width: 0}
            bufferStyle = {width: 0}
        }

        const showControls = () => !this.state.isFullScreen || v.paused || this.hasRecentlyHovered() || this.state.currentOverlay !== -1
        return (
            <div className={'VideoPlayer' + (this.state.isFullScreen ? ' fullscreen dark' : '')} ref={this.playerRef}>
                <div style={{overflow: 'hidden'}} className='VideoPlayer-display'>
                    <video
                            ref={this.props.videoRef}
                            onClick={this.playPause}
                            onLoadStart={this.showSpinner}
                            onWaiting={this.showSpinner}
                            onCanPlay={this.hideSpinner}
                            onLoadedMetadata={this.hideSpinner}
                            playsInline
                            crossOrigin="anonymous">
                        <source src={`${this.state.source[1]}#t=0.1`} type="video/mp4" />
                        <track src={this.props.data.vtt} label="English" kind="metadata" srcLang="en" default />
                    </video>
                    <MovableCaptions>
                   {this.state.showCaptions && this.state.caption && !this.state.currentPrompt && <div className='VideoPlayer-subtitle' dangerouslySetInnerHTML={{__html: this.state.caption}} />}
                    </MovableCaptions>
                    {this.state.currentPrompt
                            && <div className="VideoPlayer-promptBackground" />}
                    {this.state.currentPrompt && <Prompt
                        onClick={this.playPause}
                        sequenceId={this.props.data.sequence.id}
                        discordURL={this.props.data.sequence.discordURL}
                        discordChannelName={this.props.data.sequence.discordChannelName}
                        prompt={this.state.currentPrompt.prompt}
                        partId={this.state.currentPrompt.id} />}
                    {this.state.showSpinner && <Spinner />}
                </div>
                <div className={'VideoPlayer-bottom' + (showControls() ? ' bgGradient' : '')}>
                    
                    <div className={'VideoPlayer-controls' + (showControls() ? '' : ' hide')}>
                        <div ref={this.progressEl}
                                className="VideoPlayer-progressControlContainer">
                            <div className="VideoPlayer-noteMarkers">
                                {this.props.data.overlays.map((x, i) => <Tooltip key={i} showing={i === this.state.currentOverlay} left={100 * x[0] / v.duration + '%'}><span dangerouslySetInnerHTML={{__html: x[1]}}/></Tooltip>)}
                            </div>
                            <div className="Slider"
                                onClick={this.handleClickProgress}
                                onMouseMove={this.handleHoverProgress}
                                onMouseLeave={this.handleLeaveProgress}>
                            {(this.isScrubbing || (!!v.duration && this.state.currentTime > 0)) && <div className="Slider-handle"
                                style={{left: 100 * this.state.currentTime / v.duration + '%'}}
                                onMouseDown={this.scrubberDragStart} />}
                                <div className="Slider-groove">
                                    <div className="VideoPlayer-buffer" style={bufferStyle} />
                                    <div className="Slider-progress" style={progressStyle} />

                                </div>
                                <div className='PausePointTooltips' onMouseMove={this.hideProgressHover}> 
                                    {!!v.duration
                                        && this.props.data.sliderItems
                                        && this.props.data.sliderItems.map((x, i) => {
                                            return <Tooltip
                                                key={i}
                                                onClick={(e) => this.handleClickPauseMarker(e, x)}
                                                left={100 * x.timestamp / v.duration + '%'}
                                            >{x.title}</Tooltip>
                                        })}
                                </div>
                                {!!v.duration &&
                                    <div className='Tooltip-bubble TimestampTooltip'
                                        style={{
                                            display: this.state.progressHoverText ? 'block' : 'none',
                                            left: this.state.progressHoverLeft || 0}}
                                    ><div className='Tooltip-bubbleInner'>
                                        {this.state.progressHoverText}
                                    </div>
                                    <div className='Tooltip-triangle' />
                                    </div>}
                            </div>
                        </div>
                        <div className="VideoPlayer-controlRow">
                            <div className="VideoPlayer-controlButton VideoPlayer-playPause" onClick={this.playPause}>
                                <i className="material-icons">
                                    {v.paused ? 'play_arrow' : 'pause'}
                                </i>
                            </div>
                            <VideoVolumeControl
                                setVideoVolume={this.setVideoVolume}
                                videoVolume={this.state.videoVolume}
                                toggleVideoMuted={this.toggleVideoMuted}
                                videoMuted={this.state.videoMuted} />
                            {!!v.duration && <div className="ml2 VideoPlayer-time">
                                <span className="VideoPlayer-timeElapsed">{timeFormat(this.state.currentTime)}</span>
                                <span className='mx2' style={{display: 'inline-block'}}>/</span>
                                <span className="VideoPlayer-totalTime">{timeFormat(v.duration)}</span>
                            </div>}
                            <div className="VideoPlayer-controlRowRight">
                                {this.fullScreenEnabled && <div className="VideoPlayer-controlButton VideoPlayer-fullscreen" onClick={this.toggleFullScreen}>
                                    <i className="VideoPlayer-fullScreen material-icons">{this.state.isFullScreen ? 'fullscreen_exit' : 'fullscreen'}</i>
                                </div>}
                                <div className="VideoPlayer-sourceChanger">
                                    <div
                                        style={{
                                            backgroundColor: 'var(--bg5)',
                                            boxShadow: 'var(--elevation-2)',
                                            borderRadius: '4px'
                                        }}
                                        className="px2 py1 VideoPlayer-sourceChoices"
                                    >
                                        <span>Resolution</span>
                                        {this.props.data.sources.map((x, i) => <div key={i} onClick={() => this.setSource(i)}>{x[0]}</div>)}
                                    </div>
                                    <span className="VideoPlayer-source">{this.state.source[0]}</span>
                                </div>
                                <div className="VideoPlayer-speedChanger">
                                    <div
                                        style={{
                                            backgroundColor: 'var(--bg5)',
                                            boxShadow: 'var(--elevation-2)',
                                            borderRadius: '4px'
                                        }}
                                        className="px2 py1 VideoPlayer-speedChoices"
                                    >
                                        <span>Speed</span>
                                        <div onClick={() => this.setPlaybackRate(2.5)}>2.5x</div>
                                        <div onClick={() => this.setPlaybackRate(2.25)}>2.25x</div>
                                        <div onClick={() => this.setPlaybackRate(2)}>2x</div>
                                        <div onClick={() => this.setPlaybackRate(1.75)}>1.75x</div>
                                        <div onClick={() => this.setPlaybackRate(1.5)}>1.5x</div>
                                        <div onClick={() => this.setPlaybackRate(1.25)}>1.25x</div>
                                        <div onClick={() => this.setPlaybackRate(1)}>1x</div>
                                    </div>
                                    <span className="VideoPlayer-speed">{this.state.playbackRate}x</span>
                                </div>
                                <button className={'VideoPlayer-toggleCaptions' + (this.state.showCaptions ? ' active' : '')} type="button" onClick={this.toggleCaptions}>cc</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


const trunc = s =>
    s.length < 30 ? s : s.substring(0, 30) + '…'


const UserChip = props =>
    <a className='chip' href={`/profiles/${props.user.username}/`}>
        <img src={props.user.photo} className='profile-picture' alt={props.user.name + ' photo'} />
        {trunc(props.user.name)}
    </a>


class Comment extends React.Component {
    constructor (props) {
        super()
        this.state = {
            editing: false,
            statusClass: 'default',
            statusText: '',
        }
        this.commentRef = React.createRef()
        this.textareaRef = React.createRef()
        this.edit = this.edit.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
    }

    edit () {
        this.setState({'editing': true})
    }

    componentDidMount () {
        if (this.props.scroll && this.commentRef.current) {
            this.commentRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    handleUpdate (e) {
        // Save the user's response state
        e.preventDefault()
        const value = this.textareaRef.current.value
        this.setState({markdown: value})
        window.post(`/comments/${this.props.id}/`, {
            content: value
        })
        .then(
            (result) => {
                if (result.status === 200) {
                    this.setState({
                        statusText: '',
                        statusClass: 'default'
                    })
                    result.json().then(data => {
                        this.setState({
                            lastSave: data.id,
                            html: data.html,
                            editing: false
                        })
                    })
                } else {
                    this.setState({
                        statusText: 'An error occured while saving',
                        statusClass: 'error',
                    })
                }
            },
            (error) => {
                console.error(error)
                this.setState({
                    statusText: 'An error occured while saving',
                    statusClass: 'error',
                })
            }
        )
        this.setState({statusText: 'Saving...', statusClass: 'saving'})
    }

    render () {
        const comment = <div ref={this.commentRef} id={this.props.id} className="my2 text-smaller">
            <span dangerouslySetInnerHTML={{__html: this.state.html || this.props.html}} />
            <span> — <a href={`/profiles/${this.props.user.username}/`}>{this.props.user.name}</a>, <a className="opacity-lowest" href={`/responses/${this.props.responseId}/?c=${this.props.id}`} style={{color: 'unset'}}>{formatDistance(new Date(this.props.created), new Date(), {addSuffix: true})}</a></span>
            {(this.props.user.id === this.props.userId || this.props.isSuperuser) && !this.state.editing && <span className='link-color ml2' onClick={this.edit} style={{cursor: 'pointer'}}>edit</span>}
        </div>
        const editor = <form onSubmit={this.handleUpdate}>
            <CommentEditor statusText={this.state.statusText} statusClass={this.state.statusClass} buttonValue='save' key={this.state.lastSave} className='light' textareaRef={this.textareaRef} autofocus={true} defaultValue={this.state.markdown || this.props.markdown} />
        </form>
        return this.state.editing ? editor : comment
    }
}


class Response extends React.Component {
    constructor (props) {
        super()
        this.state = {
            commentStatusText: '',
            commentStatusClass: 'default',
            responseStatusText: '',
            responseStatusClass: 'default',
            comments: props.comments,
            votes: props.votes,
            editing: false,
            commenting: false,
            html: props.html,
            userVotes: props.userVotes  // in {-1, 0, 1}
        }
        this.responseEl = React.createRef()  // the response itself
        this.textareaEl = React.createRef()  // new comment form
        this.responseUpdateEl = React.createRef()  // edit existing response
        this.handleCommentSubmit = this.handleCommentSubmit.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.toggleUpvote = this.toggleUpvote.bind(this)
        this.toggleDownvote = this.toggleDownvote.bind(this)
        this.edit = this.edit.bind(this)
        const url = new URL(window.location.href)
        this.linkedComment = url.searchParams.get('c')
    }

    vote (value) {
        window.post('/votes/', {
            responseId: this.props.id,
            value: value
        })
        .then(
            (result) => {
                if (result.status !== 201) {
                    console.error('Error adding vote')
                }
            },
            (error) => {
                console.error(error)
            }
        )
    }

    toggleUpvote (e) {
        var value = {
            '-1': 2,
            '0': 1,
            '1': -1,
        }[this.state.userVotes]
        this.setState({
            votes: this.state.votes + value,
            userVotes: this.state.userVotes + value
        })
        this.vote(value)
    }

    toggleDownvote (e) {
        var value = {
            '-1': 1,
            '0': -1,
            '1': -2,
        }[this.state.userVotes]
        this.setState({
            votes: this.state.votes + value,
            userVotes: this.state.userVotes + value
        })
        this.vote(value)
    }

    edit (e) {
        this.setState({editing: true})
    }

    handleUpdate (e) {
        // Save the user's response state
        e.preventDefault()
        const value = this.responseUpdateEl.current.value
        this.setState({markdown: value})
        window.post(`/update-response/${this.props.id}/`, {
            content: value
        })
        .then(
            (result) => {
                if (result.status === 200) {
                    this.setState({
                        responseStatusText: '',
                        responseStatusClass: 'default'
                    })
                    result.json().then(data => {
                        this.setState({
                            html: data.html,
                            editing: false
                        })
                    })
                } else {
                    this.setState({
                        responseStatusText: 'An error occured while saving',
                        responseStatusClass: 'error',
                    })
                }
            },
            (error) => {
                console.error(error)
                this.setState({
                    responseStatusText: 'An error occured while saving',
                    responseStatusClass: 'error',
                })
            }
        )
        this.setState({responseStatusText: 'Saving...', responseStatusClass: 'saving'})
    }


    handleCommentSubmit (e) {
        e.preventDefault()
        const value = this.textareaEl.current.value
        if (value === '') { return; }
        window.post('/comments/', {
            responseId: this.props.id,
            content: value
        })
        .then(
            (result) => {
                if (result.status === 201) {
                    this.setState({
                        commentStatusText: '',
                        commentStatusClass: 'default'
                    })
                    this.textareaEl.current.value = ''
                    result.json().then(data => {
                        this.state.comments.push(data)
                        this.setState({comments: this.state.comments, lastSave: data.id})
                    })
                } else {
                    this.setState({
                        commentStatusText: 'An error occured while saving',
                        commentStatusClass: 'error',
                    })
                }
            },
            (error) => {
                console.error(error)
                this.setState({
                    commentStatusText: 'An error occured while saving',
                    commentStatusClass: 'error',
                })
            }
        )
        this.setState({commentStatusText: 'Saving...', commentStatusClass: 'saving'})
    }

    componentDidMount () {
        if (this.props.scroll) {
            this.responseEl.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    render () {
        var commentForm = (
            <form className="my2" onSubmit={this.handleCommentSubmit}>
                <CommentEditor statusText={this.state.commentStatusText} statusClass={this.state.commentStatusClass} key={this.state.lastSave} className='text-smaller light' textareaRef={this.textareaEl} rows={1} placeholder='Reply' autofocus={true} />
            </form>
        )

        return (
            <div className="Response my2 flex" ref={this.responseEl}>
                <div className='py4 px2' style={{flex: '0 0 120px', textAlign: 'center'}}>
                    <button className='button-plain button-vote' onClick={this.toggleUpvote} style={this.state.userVotes === 1 ? {color: 'green'} : {}}>
                       <i className='material-icons'>arrow_drop_up</i>
                    </button>
                    <div style={{fontSize: '36px', lineHeight: '36px'}}>{this.state.votes}</div>
                    <button className='button-plain button-vote' onClick={this.toggleDownvote} style={this.state.userVotes === -1 ? {color: 'green'} :{}}>
                       <i className="material-icons">arrow_drop_down</i>
                    </button>
                </div>
                <div className='p3 flex-auto'>
                    {this.state.editing ?
                        <form onSubmit={this.handleUpdate}>
                            <CommentEditor statusText={this.state.responseStatusText} statusClass={this.state.responseStatusClass} k buttonValue='save' className='light' textareaRef={this.responseUpdateEl} defaultValue={this.state.markdown || this.props.markdown} autofocus={true} />
                        </form> :
                        <div className='clearfix mb2'>
                            <div dangerouslySetInnerHTML={{__html: this.state.html}} />
                            <div className='my3' style={{textAlign: 'right'}}>
                                {(this.props.user.id === this.props.userId || this.props.isSuperuser) && !this.state.editing && <span onClick={this.edit} className='mr3 link-color' style={{cursor: 'pointer'}}>edit</span>}
                                <UserChip user={this.props.user} />
                                <span style={{display: 'inline-block'}} className='mx2 opacity-lowest text-smaller'>
                                    <a href={`/responses/${this.props.id}`} style={{color: 'unset'}}>{formatDistance(new Date(this.props.created), new Date(), {addSuffix: true})}</a>
                                </span>
                            </div>
                        </div>}
                    {this.props.isSuperuser && this.props.review && <div className='mt2 mr2 mb3 muted text-smaller'><h3 className='mb1'>Autoreview</h3><div dangerouslySetInnerHTML={{__html: this.props.review}} /></div>}
                    <div style={{maxWidth: '50rem'}}>
                        <span className="text-smaller">
                            <i className='material-icons' style={{verticalAlign: 'sub', fontSize: '16px', marginRight: '4px'}}>comment</i>{this.state.comments.length + (this.state.comments.length === 1 ? ' reply' : ' replies')}</span>
                    {this.state.comments.map(x => <Comment key={x.id} scroll={this.linkedComment === x.id} responseId={this.props.id} isSuperuser={this.props.isSuperuser} userId={this.props.userId} {...x} />)}
                    {this.state.commenting ? commentForm : <div className='mt2'> <button className='button reply-button' onClick={() => this.setState({commenting: true})}>reply</button></div>}
                    </div>
                </div>
            </div>
        )
    }
}

// Either comment style ProblemResponses, or submission style ProblemResponses... both the list and ability to add more
class Responses extends React.Component {
    constructor(props) {
        super(props)
        const getLocal = (key, dflt) => localStorage.getItem(key) || dflt
        let langPref = getLocal('responseLang', 'any')
        if (langPref !== 'any') {
            let langOk = false
            for (let i = 0; i < props.data.responseLanguages.length; i++) {
                if (langPref === props.data.responseLanguages[i][0]) {
                    langOk = true
                    break
                }
            }
            if (!langOk) langPref = 'any'
        }
        this.state = {
            statusText: '',
            statusClass: 'default',
            order: getLocal('responseOrder', 'latest'),
            lang: langPref,
            loadingSubmissions: false,
            mayBeMore: true  // whether or not to keep fetching on paginate... remember to set back if filters etc change!
        }
        this.ref = React.createRef()
        this.textareaEl = React.createRef()
        this.handleSubmit = this.handleSubmit.bind(this)
        this.changeOrder = this.changeOrder.bind(this)
        this.changeLanguage = this.changeLanguage.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    load (after) {
        const params = new URLSearchParams({
            order: this.state.order,
            lang: this.state.lang
        })
        if (after) params.set('after', after)
        fetch(`/submissions/${this.props.data.id}/?${params}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(
            (result) => {
                this.setState({loadingSubmissions: false})
                if (result.status === 200) {
                    result.json().then(data => {
                        const res = this.props.responses
                        const prior = new Set(res.map(x => x.id))
                        for (let x of data.responses)
                            if (!prior.has(x.id)) res.push(x)
                        this.setState({mayBeMore: data.responses.length === 10})
                        this.props.setResponses(res)
                    })
                }
            },
            (error) => {
                console.error(error)
                this.setState({
                    loadingSubmissions: false
                })
            }
        )
        this.setState({
            loadingSubmissions: true
        })
    }

    changeOrder (e) {
        this.props.setResponses([])
        this.setState({order: e.target.value}, this.load)
        localStorage.setItem('responseOrder', e.target.value)
    }

    changeLanguage (e) {
        this.props.setResponses([])
        this.setState({lang: e.target.value}, this.load)
        localStorage.setItem('responseLang', e.target.value)
    }

    componentDidMount () {
        if (this.props.responseStyle === 'submission') this.load()
        document.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount () {
        document.removeEventListener('scroll', this.handleScroll)
    }

    handleSubmit (e) {
        e.preventDefault()
        const value = this.textareaEl.current.value
        window.post('/responses/', {
            problemId: this.props.data.id,
            content: value,
            style: this.props.responseStyle,
        })
        .then(
            (result) => {
                if (result.status === 201) {
                    this.setState({
                        statusText: '',
                        statusClass: 'default'
                    })
                    this.textareaEl.current.value = ''
                    result.json().then(data => {
                        this.props.responses.unshift(data)
                        this.props.setResponses(this.props.responses)
                        this.setState({lastSave: data.id})
                    })
                } else {
                    this.setState({
                        statusText: 'An error occured while saving',
                        statusClass: 'error',
                    })
                }
            },
            (error) => {
                console.error(error)
                this.setState({
                    statusText: 'An error occured while saving',
                    statusClass: 'error',
                })
            }
        )
        this.setState({statusText: 'Saving...', statusClass: 'saving'})
    }

    handleScroll () {
        if (this.props.responseStyle !== 'submission') return
        if (this.ref.current.offsetParent === null) return
        if (this.state.loadingSubmissions) return
        if (!this.state.mayBeMore) return
        if (this.ref.current.getBoundingClientRect().bottom - window.innerHeight < 100) {
            const prior = this.props.responses[this.props.responses.length-1]
            if (prior) this.load(prior.id)
        }
    }
   
    render () {
        return <div ref={this.ref}>
            <div className='clearfix'> 
                <form style={{maxWidth: '55rem'}} className='my2 py3' onSubmit={this.handleSubmit}>
                    <CommentEditor statusText={this.state.statusText} statusClass={this.state.statusClass} key={this.state.lastSave} textareaRef={this.textareaEl} className='light' autofocus={false} placeholder={this.props.placeholder} />
                </form>
            </div>
            {this.props.responseStyle === 'submission' && this.props.responses.length > 0 && <div className='my3'>
                Order by <select value={this.state.order} className='ml2 mr4 select' onChange={this.changeOrder}><option value="latest">Latest</option><option value="top">Top voted</option></select>
                Language <select value={this.state.lang} className='ml2 select' onChange={this.changeLanguage}>
                    <option value='any'>any</option>
                    {this.props.data.responseLanguages.map(x => <option value={x[0]}>{x[1]} ({x[2]})</option>)}
                </select>
            </div>}
            {this.props.responses.map(x => <Response
                key={x.id}
                userId={this.props.data.userId}
                isSuperuser={this.props.data.isSuperuser}
                userVotes={this.props.data.userVotes[x.id] || 0}
                {...x} />)}
            {this.state.loadingSubmissions && <Spinner style={{width: '70px', marginLeft: '45%'}} className='mt3 static black' />}
        </div>
    }
}


class ResponsesContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activePanel: 'comments',
            responses: this.props.data.responses,
            submissions: []
        }
        this.setActivePanel = (x) => this.setState({activePanel: x})
        this.setResponses = (x) => {
            this.setState({responses: x})
        }
        this.setSubmissions = (x) => {
            this.setState({submissions: x})
        }
    }

    render () {
        const comments = <Responses
            responses={this.state.responses}
            placeholder='Leave a comment or ask a question'
            data={this.props.data}
            setResponses={this.setResponses}
            responseStyle='comment' />
        if (this.props.data.style === 'Problem') {
            const numSubmissions = Math.max(this.props.data.submissionCount, this.state.submissions.length)
            return <div className='pt2'>
                <div className='simple-tabs mb3'>
                    <div className={'ml2 tab' + (this.state.activePanel === 'comments' ? ' active' : '')} onClick={() => this.setActivePanel('comments')}>{this.state.responses.length} comment{this.state.responses.length === 1 ? '' : 's'}</div>
                    <div className={'tab' + (this.state.activePanel === 'submissions' ? ' active' : '')} onClick={() => this.setActivePanel('submissions')}>{numSubmissions} submission{numSubmissions === 1 ? '' : 's'}</div>
                </div>
                <div className={'tab-panel' + (this.state.activePanel === 'comments' ? ' active' : '')}>
                    {comments}
                </div>
                <div className={'tab-panel' + (this.state.activePanel === 'submissions' ? ' active' : '')}>
                    <Responses
                        responses={this.state.submissions}
                        placeholder='Share a submission'
                        data={this.props.data}
                        setResponses={this.setSubmissions}
                        responseStyle='submission' />
                </div>
            </div>
        }
        return <div className='pt2'>
           <div>{this.props.data.responses.length} comment{this.props.data.responses.length === 1 ? '' : 's'}</div>
           {comments}
        </div>
    }
}


class Recording extends React.Component {

    constructor (props) {
        super(props)
        this.videoRef = React.createRef()
        this.state = {
            isComplete: this.props.data.isComplete
        }
        this.toggleComplete = this.toggleComplete.bind(this)
    }

    toggleComplete () {
        const value = !this.state.isComplete
        window.post('/mark-complete/', {
            recordingId: this.props.data.id,
            value: value
        })
        .then(
            (result) => {
                if (result.status === 201) {
                    this.setState({
                        isComplete: value
                    })
                } else {
                    console.error('Error marking complete')
                }
            },
            (error) => {
                console.error(error)
            }
        )
    }

    render() {
        return <>
            <div className='flex' style={{flexDirection:'column', height: '80vh'}}>
                <VideoPlayer data={this.props.data} videoRef={this.videoRef} />
            </div>
            <div className='container py4 clearfix'>
                <div className='col col-12 md-col-3 py1 md-py2 px1 md-px3 md-right'>
                    <h1>{this.props.data.name}</h1>
                    <div className='mt2 mb2'>
                        <span className='tag'>{this.props.data.style}</span>
                        {this.props.data.free && <span className='tag mustard ml2'>FREE</span>}
                        {this.props.data.freeUntilStr && <span className='tag mustard ml2'>FREE FOR {this.props.data.freeUntilStr}</span>}
                    </div>
                    <div className='mb4'>{this.props.data.sequence.courseName !== 'unassigned' &&
                        <small>
                            <a href={this.props.data.sequence.courseUrl}>{this.props.data.sequence.courseName}</a>:&nbsp;
                            <a href={this.props.data.sequence.url}>{this.props.data.sequence.name}</a>
                        </small>}
                    </div>
                    {this.props.data.hasFiles && <a className='button mb4' href={'/problems/' + this.props.data.id + '.zip'} style={{lineHeight: '38px', height: '38px', fontSize: '18px'}}><i className='material-icons' style={{lineHeight: '38px', height: '38px', verticalAlign: 'middle', marginRight: '4px', marginLeft: '-2px'}}>download</i>Get files</a>}
                    {this.props.data.style === 'Problem' && this.props.data.userId && 
                   <div className="flex justify-start md-justify-end" style={{fontSize: '22px', marginBottom: 'var(--space-4)'}}>
                        <input className="completion" onChange={this.toggleComplete} id={this.props.data.id + '-completion'} type="checkbox" checked={this.state.isComplete ? 'checked' : ''} />
                        <label htmlFor={this.props.data.id + '-completion'}>Mark complete: <span className="ml2"></span></label>
                   </div>}
                </div>
                <div className='col col-12 md-col-9 py1 md-py2 px1 md-px3'>
                {this.props.data.description && <div className='description pb4' style={{maxWidth: '55rem'}} dangerouslySetInnerHTML={{__html: this.props.data.description }} />}
                    
              {this.props.data.isSubscriber ? <ResponsesContainer data={this.props.data} />
                  : <div className="my4 p4 center" style={{fontSize: '1.2em', background: 'var(--bg2)', boxShadow: 'var(--elevation-1)'}}>
                  <i className='material-icons mr2' style={{verticalAlign: 'text-bottom'}}>lock</i>
                  Commenting and code submission is for subscribers only. <a href="/subscribe/">Subscribe now</a>.</div>}
                </div>
            </div>
        </>
    }
}


const ResponsePermalink = (props) => {
    const res = props.data.responses[0]
    return (
        <div className='container py4 clearfix flex'>
            <div className='col col-12 md-col-9' style={{margin: 'auto'}}>
                <h2 className='mt2 mb4'>{res.style} from {res.user.name} on <a href={`/watch/${props.data.id}/`}>{props.data.name}</a></h2>
                <Response
                    isSuperuser={props.data.isSuperuser}
                    userId={props.data.userId}
                    userVotes={props.data.userVotes[res.id] || 0}
                    {...res} />
            </div>
        </div>
    )
}


export {Recording, ResponsePermalink}

